import React from 'react';
import { StyleSheet, Text } from 'react-native';
import Theme from 'Theme';
import { Background } from 'LocalGluons';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        marginHorizontal: 20,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center'
    }
});

class TextPage extends React.Component {
    constructor(props) {
        super(props);
        this.pageOptions = null;
    }

    render() {
        // TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659
        // eslint-disable-next-line react/prop-types
        const { route } = this.props;
        this.pageOptions = route.params?.pageOptions || undefined;

        return (
            <Background>
                {/* TODO: Fix linting error https://jira.24i.com/browse/PRJ1260EXT-4659 */}
                {/* eslint-disable-next-line react/self-closing-comp */}
                <Text style={styles.text}></Text>
            </Background>
        );
    }
}

export default TextPage;
